import { c as _c } from "react/compiler-runtime";
const NotificationSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-skeleton-primary h-[80px] w-full animate-pulse rounded-sm" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const NotificationsListSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-background-secondary flex w-full flex-col items-center justify-center gap-3 px-6 py-4"><NotificationSkeleton /><NotificationSkeleton /><NotificationSkeleton /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default NotificationsListSkeleton;